module.exports = __webpack_public_path__ + "img/1582665072.71c67186.jpg";